import axios, {AxiosInstance} from "axios";
import {getJwt, deleteJwt} from "../Auth/Auth";

const api: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

let redirectToLogin: (() => void) | null = null;

export function setRedirectHandler(handler: () => void) {
    redirectToLogin = handler;
}

api.interceptors.request.use((config) => {
    const token: string | null = getJwt();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403) {
            if (getJwt() === null) {
                if (redirectToLogin) {
                    redirectToLogin();
                }
            }
        }
        return Promise.reject(error);
    }
);

export default api;